import React from 'react'
import SbEditable from 'storyblok-react'
import ButtonPrimary from './../ButtonPrimary'

const Button = (props) => {
	return (
		<SbEditable content={props.blok}>
            <ButtonPrimary link={props.blok.link} label={props.blok.label} />
		</SbEditable>
	)
}

export default Button
